export const getRepositoryRequestBody = (params) => {
  return {
    name: params?.keyName,
    description: params?.description, // optional
    type: 'SSH', // fixed or inferred default
    auth: {
      key_type: params?.keyType,
      private_key: `${params?.sshKey}\n`,
    },
    url: params?.repositoryUrl,
  }
}

export const validateSshKeyRequestBody = (params) => {
  return {
    name: params?.keyName,
    description: params?.description, // optional
    type: 'SSH', // fixed or inferred default
    auth: {
      key_type: params?.keyType,
      private_key: `${params?.sshKey}\n`,
    },
    url: params?.repositoryUrl,
  }
}

export const convertMBToGB = (mb) => {
  if (mb === undefined) return undefined
  const gb = mb / 1000
  return gb.toFixed(2)
}

export const calculateResourceTotals = (resources: any[]) => {
  return resources?.reduce(
    (acc, res) => {
      const { ram = 0, vcpus = 0, disk = 0 } = res?.flavor || {}
      acc.totalRam += ram
      acc.totalVcpus += vcpus
      acc.totalDisk += disk
      return acc
    },
    { totalRam: 0, totalVcpus: 0, totalDisk: 0 },
  )
}
